var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('div',{staticClass:"content"},[_c('AddWeb',{staticStyle:{"margin-bottom":"23px"}}),_c('NavList',{staticStyle:{"padding-top":"10px"}})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }